import { DeploymentProgressMessages } from './deployment-messages';

/**
 * Deployment Status Types - Available deployment statuses
 */
export const DeploymentStatusTypes = {
  PROCESSING: 'processing',
  DEPLOYING: 'deploying',
  VERIFYING: 'verifying',
  ARGOCD_SYNC: 'argocd_sync',  // NEW: ArgoCD sync in progress
  DONE: 'done',
  FAILED: 'failed'
} as const;

/**
 * Progress Message Configuration Interface
 */
export interface ProgressMessageConfig {
  after: number;
  message: string;
}

/**
 * Production Progress Messages Configuration
 * Based on polling attempts (every 10s), max 42 attempts = 7 minutes
 */
export const PRODUCTION_PROGRESS_MESSAGES: ProgressMessageConfig[] = [
  { after: 0, message: DeploymentProgressMessages.SETTING_UP_DOMAIN },      // 0 seconds (immediate)
  { after: 3, message: DeploymentProgressMessages.UPLOADING_CONTENT },      // 30 seconds
  { after: 9, message: DeploymentProgressMessages.CONFIGURING_WEBSITE },    // 90 seconds
  { after: 15, message: DeploymentProgressMessages.RUNNING_TESTS },         // 150 seconds (2.5 min)
  { after: 21, message: DeploymentProgressMessages.TAKING_LONGER },         // 210 seconds (3.5 min)
  { after: 27, message: DeploymentProgressMessages.ALMOST_READY },          // 270 seconds (4.5 min)
  { after: 33, message: DeploymentProgressMessages.FINALIZING }             // 330 seconds (5.5 min)
];

/**
 * Development Progress Messages Configuration
 * Slightly faster progression for development environment
 */
export const DEVELOPMENT_PROGRESS_MESSAGES: ProgressMessageConfig[] = [
  { after: 0, message: DeploymentProgressMessages.SETTING_UP_DOMAIN },      // 0 seconds (immediate)
  { after: 2, message: DeploymentProgressMessages.UPLOADING_CONTENT },      // 20 seconds
  { after: 6, message: DeploymentProgressMessages.CONFIGURING_WEBSITE },    // 60 seconds
  { after: 12, message: DeploymentProgressMessages.RUNNING_TESTS },         // 120 seconds (2 min)
  { after: 18, message: DeploymentProgressMessages.TAKING_LONGER },         // 180 seconds (3 min)
  { after: 24, message: DeploymentProgressMessages.ALMOST_READY },          // 240 seconds (4 min)
  { after: 30, message: DeploymentProgressMessages.FINALIZING }             // 300 seconds (5 min)
]; 